module.exports = __webpack_public_path__ + "static/media/ldi-user-guide.03bf7862.pdf";